import { FC } from 'react';
import Link from 'next/link';
import { isEmpty } from 'radash';
import { ISearchTag } from '@modules/search/domain/models/searchTag.model';
import { RecentlySearchList } from './SearchBox';
import { GridWrapper, ResultGridWrapper, SearchTag, SearchTitle, TagWrapper } from './SearchBox.style';
interface Props {
  recentlySearch: RecentlySearchList[];
  popularSearch: ISearchTag[];
  onSelectedTag: (shouldReloadPage: boolean) => void;
}
const ResultGrid: FC<Props> = ({
  recentlySearch,
  popularSearch,
  onSelectedTag
}: Props) => {
  const renderSearchResult = (searchTitle: string, data: ISearchTag[] | RecentlySearchList[], isPopularSearch: boolean, maxLineTag?: number) => {
    return <GridWrapper>
                <SearchTitle>{searchTitle}</SearchTitle>
                <TagWrapper $maxLineTag={maxLineTag}>
                    {data?.map(({
          linkOut,
          text,
          id
        }) => <Link href={linkOut} key={id}>
                            <div onClick={() => onSelectedTag(!isPopularSearch)}>
                                <SearchTag>{text}</SearchTag>
                            </div>
                        </Link>)}
                </TagWrapper>
            </GridWrapper>;
  };
  return <ResultGridWrapper>
            {!isEmpty(recentlySearch) && renderSearchResult('ค้นหาล่าสุด', recentlySearch, false, 2)}
            {!isEmpty(popularSearch) && renderSearchResult('ยอดนิยม', popularSearch, true)}
        </ResultGridWrapper>;
};
export default ResultGrid;